import {ControllerParams as YoshiControllerParams, CreateControllerFn} from '@wix/yoshi-flow-editor';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {AppDataWithContext} from '../../types/types';

export const conditionalController =
  (
    experimentName: string,
    controllerWhenTrue: CreateControllerFn,
    controllerWhenFalse: CreateControllerFn
  ): CreateControllerFn =>
  (controllerParams: YoshiControllerParams) => {
    const appData = controllerParams.appData as AppDataWithContext | undefined;
    const siteStore: SiteStore | undefined = appData?.context?.siteStore;

    if (!siteStore?.experiments.enabled(experimentName)) {
      return controllerWhenFalse(controllerParams);
    }

    return controllerWhenTrue(controllerParams);
  };
